import { Pipe, PipeTransform } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';

@Pipe({
  name: 'highlight',
  pure: true
})
export class HighlightPipe implements PipeTransform {
  constructor(private sharedService: SharedService) { }
  transform(value: string[]): string {
    return value?.map(_ => this.sharedService.stripHtmlTags(_, ['em'])).join('&nbsp;&nbsp;');
  }


}
